import type * as React from 'react';
import { cn } from '../../lib/cn.ts';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}

function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  'data-testid': testId,
}: EmptyStateProps) {
  return (
    <div
      data-testid={testId ?? 'empty-state'}
      className={cn(
        'flex flex-col items-center justify-center gap-4',
        'py-16 px-6 text-center',
        className,
      )}
    >
      {icon && (
        <div
          aria-hidden="true"
          className="text-[var(--color-warm-stone-soft)] [&>svg]:size-10 [&>svg]:stroke-[1.3]"
        >
          {icon}
        </div>
      )}
      <div className="flex flex-col gap-1.5 max-w-sm">
        <h3 className="font-[var(--font-display)] text-base font-medium text-[var(--color-charcoal)] tracking-tight">
          {title}
        </h3>
        {description && (
          <p className="text-sm text-[var(--color-stone-mid)] leading-relaxed">{description}</p>
        )}
      </div>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}

export { EmptyState };
